if (!customElements.get('parfumine-purchase-trust')) {
  customElements.define(
    'parfumine-purchase-trust',
    class ParfuminePurchaseTrust extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.freeShippingThreshold) || 0;
        this.shippingLabel = this.querySelector('[data-parfumine-trust-shipping]');
        this.deliveryNote = this.querySelector('[data-parfumine-trust-delivery]');

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          // Hızlı ekleme penceresinde section kimliği önek alır; olay öneksiz kimliği taşır.
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section;
          if (sectionId && event.data.sectionId !== sectionId) return;

          this.update(event.data.variant);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      // Kargo satırını seçili varyantın fiyatına göre günceller (fiyat cent cinsinden gelir).
      update(variant) {
        if (!variant) return;

        const isFree = variant.price >= this.threshold;
        if (this.shippingLabel) {
          this.shippingLabel.textContent = isFree ? this.dataset.labelFree : this.dataset.labelPaid;
        }
        if (this.deliveryNote) this.deliveryNote.hidden = !variant.available;
      }
    }
  );
}
